import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Avatar from "../../../assets/img/default-image.jpg";

const StackedAvatars = ({ recipients = [], onAvatarClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();

  if (!recipients || recipients.length === 0) {
    return null;
  }

  const handleAvatarClick = (e, recipient) => {
    e.stopPropagation();
    if (onAvatarClick) {
      onAvatarClick(recipient);
    }
  };

  return (
    <div 
      className="relative flex items-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setHoveredIndex(null);
      }}
    >
      <div className={`flex items-center transition-all duration-300 ${isHovered ? 'gap-1' : '-space-x-9'}`}>
        {recipients.slice(0, 5).map((recipient, index) => (
          <div
            key={recipient.id || index}
            className={`relative transition-all duration-300 cursor-pointer border-3 border-white rounded-full ${
              isHovered 
                ? 'transform scale-100 z-10' 
                : 'transform scale-90 hover:scale-100 hover:z-10'
            }`}
            style={{
              zIndex: isHovered ? 10 - index : 5 - index,
              borderWidth: '3px',
            }}
            onClick={(e) => handleAvatarClick(e, recipient)}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            title={recipient.name || `User ${index + 1}`}
          >
            <img
              src={recipient.image || Avatar}
              alt={recipient.name || `User ${index + 1}`}
              className="size-12 rounded-full object-cover shadow-sm transition-all duration-300"
              onError={(e) => {
                e.target.src = Avatar;
              }}
            />
            {hoveredIndex === index && recipient.name && (
              <div className="absolute -bottom-7 left-1/2 transform -translate-x-1/2 bg-offblack text-white text-xs px-2 py-1 rounded whitespace-nowrap z-20 shadow-lg">
                {recipient.name}
              </div>
            )}
          </div>
        ))}
        {recipients.length > 5 && (
          <div className={`size-12 rounded-full bg-lightgray border-3 border-white flex items-center justify-center text-xs font-semibold text-offblack flex-shrink-0 transition-all duration-300 ${isHovered ? 'ml-2' : ''}`} style={{ borderWidth: '3px' }}>
            +{recipients.length - 5}
          </div>
        )}
      </div>
    </div>
  );
};

export default StackedAvatars;
